module.exports = __webpack_public_path__ + "assets/favicons/top-nav-sidebar-toggle.svg";